<template>
  <div>
    <h4>{{ data.title }} <span class="text-success">({{ descriptionType }})</span></h4>

    <div class="mb-4" v-if="data.description">
      <div v-html="data.description"></div>
    </div>

    <div class="mb-4" v-html="condition">
    </div>

    <div v-if="data.metadata.variants.length">
      <h6 class="my-2">Ответы:</h6>
      <ul>
        <li v-for="(answer, k) in answers" :key="k">

          <div :class="`questions-test true`">
            <div class="questions-test-title">
              <h6>{{ answer.value }}</h6>
              <span class="badge badge-success">Правильный</span>
            </div>
          </div>

          <div v-for="(variant, k2) in answer.variants">
            <div :class="`questions-test ${answer.value}`">
              <div class="questions-test-title">
                <h6>{{ variant }}</h6>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import RichEditor from "@/components/Editor/RichTextEditor.vue";
import MissingWordMixin from "@/components/Item/WorkView/Type/MissingWordMixin.vue";

export default {
  data() {
    return {
      editorOption: {
        modules: {
          toolbar: [],
        },
        readOnly: true,
        theme: "snow",
      },
    };
  },
  mixins: [MissingWordMixin],
  props: ["data", "descriptionType"],
  components: {
    RichEditor,
  },
  methods: {
    focus(event) {
      event.enable(false);
    },
  },
};
</script>
